<template>
  <div class="service" style="background: #fcfcfc">
    <headbox></headbox>
    <div class="searchbox">
      <div class="searl">
        <div class="sertit">产业服务</div>
        <ul>
          <li>企业服务 <span>></span></li>
          <li>行业统计<span>></span></li>
          <li id="serlistbox">“蓉贝”人才<span>></span></li>
          <li>软洽会<span>></span></li>
          <li>软件大赛<span>></span></li>
          <li>信息通信大会<span>></span></li>
        </ul>
      </div>
      <div class="seabl">
        <p class="dqwz">当前位置：<span>首页</span>>><span>产业服务 </span>>><span>“蓉贝”人才</span></p>
        <div class="sercont">
          <h1>成都蓉贝软件人才融媒体平台</h1>
          <h4>“蓉贝”计划评价</h4>
          <p>
            “蓉贝”计划实施以来，推动成都软件产业规模得到提升、创新活力有效激发、关键领域取得突破、人才集聚效应增强、城市影响力持续扩大，初步形成涵盖“八名”要素的完整产业生态体系。“蓉贝”计划的成功实践，为全国软件产业的高质量发展提供了宝贵经验和创新启示。
          </p>
          <h4>推动成都软件量质提升</h4>
          <p>
            在“蓉贝”计划持续发力下，“蓉贝”软件人才所在企业竞争力取得了长足进步，“名企”效应进一步凸显，支撑成都软件产业量质迈向新台阶
          </p>
        </div>
        <div class="seabtnbox">
          <button>了解更多</button>
        </div>
      </div>
    </div>
    <footbox></footbox>
  </div>
</template>
<script>
import headbox from "../components/head.vue";
import footbox from "@/components/footer.vue";
export default {
  name: "service",
  //声明传递过来的子组件
  components: {
    headbox,
    footbox,
  },
};
</script>
<style lang="less" scoped>
.searchbox {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  text-align: left;
  margin-top: 20px;
}
.searl {
  flex: 2;
   @media screen and (max-width:800px) {
    display: none;
  }
}

.seabl {
  flex: 8;
}
.sertit {
  width: 100%;
  height: 46px;
  line-height: 46px;
  background: #ff9900;
  color: #fff;
  font-size: 24px;
  padding-left: 15px;
}
.searl > ul {
  margin-top: 11px;
}
.searl > ul > li {
  height: 39px;
  padding-left: 15px;
  border-bottom: 1px solid #e4e4e4;
  line-height: 39px;
  font-size: 16px;
  color: #7a7a7a;
}
.searl > ul > li > span {
  float: right;
  color: #e4e4e4;
}
#serlistbox {
  background: #42a5f6;
  color: #fff;
}
.dqwz {
  margin-left: 64px;
}
.sercont {
  margin: 30px 33px 0 110px;
}
.sercont > h1 {
  text-align: center;
}
.sercont > h4 {
  color: #525252;
  font-size: 16px;
  margin-top: 20px;
}
.sercont > p {
  color: #7a7a7a;
  font-size: 16px;
  text-indent: 2rem;
}
.seabtnbox {
  margin-top: 30px;
  text-align: center;
}
.seabtnbox > button {
  border: 2px solid #00aaeb;
  color: #00aaeb;
  border-radius: 10pt 10pt 10pt 10pt;
  height: 42px;
  width: 126px;
  font-size: 20px;
  background: #fff;
  margin: 0 auto;
}
@media screen and(max-width:650px) {
  .searchbox {
    display: block;
  }
  .dqwz {
    margin-left: 15px;
  }
  .sercont {
    margin: 10px;
  }
}
</style>
